import { initialData } from '../../types/initialData'
import { formatDate, formatMySqlDate, getLatestActivityCourse, getPrettyDate, isTimestamp, parseDate } from '../../utils'

export type CourseReport = {
    courseId: number,
    course: string
    enrolled: number
    completed: number
    inProgress: number
    notStarted: number
}

const convertToCourseReport = (data: initialData, teamData) => {
  const datePickerStartDate = parseDate( formatDate( data.datePicker.start ) ) 
  const datePickerEndDate = parseDate( formatDate( data.datePicker.end ) )
  const dateTeamCreatedOn = parseDate( formatMySqlDate( teamData.team_created_on ) )

  const courses = data.courses.map(course => {
    const enrolled = course.assigned ?? data.user_count
    const users = data.users ?? []

    const completed = users.filter(user =>
      user.progress.some(progress => progress.course_id == course.course_id && progress.status === 'completed')
    ).length
    const inProgress = users.filter(user =>
      user.progress.some(progress => progress.course_id == course.course_id && progress.status === 'in_progress')
    ).length
    const notStarted = enrolled - (completed + inProgress)

    const latestActivity = getLatestActivityCourse( users, course.course_id )
    const formattedDate = isTimestamp( latestActivity ) ? parseDate( getPrettyDate( latestActivity, 'date' ) ) : dateTeamCreatedOn

    return {
      courseId: +course.course_id,
      course: course.course_title,
      enrolled,
      completed,
      inProgress,
      notStarted,
      latestActivity: formattedDate
    }
  })

  const isInitialLoad =  formatDate( data.datePicker.start ) === formatMySqlDate( teamData.team_created_on )

  //return all
  if( isInitialLoad ) return courses

  const filteredCourses = courses.filter(course => {
    const lastActivityDate = course.latestActivity

    return lastActivityDate >= datePickerStartDate && lastActivityDate <= datePickerEndDate
  })
  
  return filteredCourses
}

export const CourseReportData = (data: initialData, teamData) => {
  return convertToCourseReport(data, teamData)
}
